import React from 'react';
import ReactDOM from 'react-dom/client';
import { StytchB2BProvider } from '@stytch/react/b2b';
import App from './App';
import { stytch } from '@/lib/stytch';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StytchB2BProvider stytch={stytch}>
      <App />
    </StytchB2BProvider>
  </React.StrictMode>,
);
